module.exports = __webpack_public_path__ + "static/media/add-treatment.573ea191.svg";